export function SaunaRange() {
  return (
    <section id="our-saunas" aria-labelledby="sauna-range-title" className="scroll-mt-28 container mx-auto max-w-7xl px-4 py-10">
      <div className="rounded-3xl border border-border bg-card p-6 md:p-9">
        <p className="text-xs font-semibold uppercase tracking-widest text-orange-600 mb-3">Made for your space</p>
        <h2 id="sauna-range-title" className="font-display text-3xl font-bold mb-5">Our saunas. Your size.</h2>
        <ul className="grid grid-cols-2 lg:grid-cols-4 gap-3 mb-6">
          {["Traditional Saunas", "Infrared Saunas", "Commercial Saunas", "Outdoor Saunas"].map(type => (
            <li key={type} className="rounded-xl bg-secondary px-4 py-4 font-semibold">{type}</li>
          ))}
        </ul>
        <div className="grid md:grid-cols-2 gap-6 text-muted-foreground leading-relaxed">
          <div>
            <h3 className="text-foreground font-bold text-xl mb-2">Custom-sized saunas</h3>
            <p>We offer custom sauna sizes to suit your room, garden building or commercial space. Share your dimensions and intended use so we can plan the layout, seating and equipment around your project.</p>
          </div>
          <div>
            <h3 className="text-foreground font-bold text-xl mb-2">Harvia heaters · dual-heater options</h3>
            <p>We use Harvia sauna heaters and can specify two heaters where suitable for the design. Heater sizing, controls, clearances, ventilation and electrical capacity are checked together against the selected equipment’s requirements. Infrared cabins use a different heating system.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
